import Swiper from "swiper";
import {A11y, Autoplay, Keyboard} from 'swiper/modules';

new Swiper('.image-swiper', {
    slidesPerView: 2,
    spaceBetween: 0,
    watchSlidesProgress: true,
    loop: true,
    modules: [Keyboard, A11y, Autoplay],
    keyboard: {
        enabled: true,
        pageUpDown: false
    },
    autoplay: {
        delay: 4000,
        disableOnInteraction: true
    },
    breakpoints: {
        768: {
            slidesPerView: 3
        },
        1200: {
            slidesPerView: 3,
        },
    }
});

